/**
 * OT-0F.1 — Patient-facing campaign visibility panel.
 *
 * PDP-001 R6F: now sources every campaign card from the canonical
 * `CampaignCardFull` renderer in `CampaignRenderers/`, so the
 * provider-side "patient preview" and the patient-facing public
 * profile render IDENTICAL cards by construction.  No alternate
 * mocked preview path survives.
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from './ui/badge';
import { Tag } from 'lucide-react';
import { CampaignCardFull } from './CampaignRenderers/CanonicalCampaignRenderers';

export default function ActiveCampaignsPanel({ campaigns, clinicId, clinicName, onRequest }) {
  const { t } = useTranslation();
  const list = (campaigns || []).filter((c) => c && c.campaign_id);
  if (list.length === 0) return null;

  return (
    <section
      id="campaigns-section"
      className="space-y-3 scroll-mt-24"
      data-testid="active-campaigns-panel"
      data-render-generation="PDP002-R2"
      data-render-authority="ActiveCampaignsPanel-v2"
      data-sprint-fingerprint="COM-FOUNDATION"
      aria-label={t('internationalOffer.heading')}
    >
      <div className="flex items-center gap-2">
        <Tag className="h-4 w-4 text-emerald-600" />
        <h2 className="text-sm font-semibold text-[#122033] font-[Manrope]" data-testid="active-campaigns-heading">
          {t('internationalOffer.heading')}
        </h2>
        <Badge
          className="bg-emerald-50 text-emerald-700 border border-emerald-200 text-[10px]"
          data-testid="active-campaigns-count"
        >
          {list.length}
        </Badge>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {list.map((c, i) => (
          <CampaignCardFull
            key={c.campaign_id}
            campaign={c}
            index={i}
            onRequest={onRequest}
            testidPrefix="campaign-card"
          />
        ))}
      </div>
    </section>
  );
}
